import {CustomerStatusReason} from 'app/blocks/model/customer-status-reason.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {ICustomerStatusReason} from 'app/blocks/model/customer-status-reason.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class CustomerStatusReasonService extends EntityCrudService<ICustomerStatusReason> {
    constructor(http: HttpClient) {
        super(http, Resource.CUSTOMER_STATUS_REASONS, (obj?) => new CustomerStatusReason(obj));
    }
}
